import SingleUpcomingAppointment from "./SingleUpcomingAppointment";

function ListUpcomingAppointments({ agendamentos, mostrarTodos }) {
  return (
    <div className="single-cliente__agendamentos">
      {agendamentos.map((agendamento, index) => (
        <SingleUpcomingAppointment
          agendamento={agendamento}
          key={index}
          mostrarTodos={mostrarTodos}
        />
      ))}
    </div>
  );
}

export default ListUpcomingAppointments;
